import React, { FunctionComponent } from 'react';

interface VerifiedBadgeProps {
  className?: string;
}

const VerifiedBadge: FunctionComponent<VerifiedBadgeProps> = ({
  className,
}) => {
  return (
    <svg
      className={className || ''}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M9.60698 1.36539C10.3362 0.617086 11.5388 0.617086 12.268 1.36539C12.7432 1.85306 13.4472 2.04167 14.1025 1.85695C15.1082 1.57349 16.1497 2.17482 16.4071 3.18747C16.5748 3.84741 17.0901 4.36271 17.75 4.53043C18.7627 4.78778 19.364 5.82931 19.0806 6.83496C18.8958 7.49034 19.0844 8.19426 19.5721 8.66948C20.3204 9.39867 20.3204 10.6013 19.5721 11.3305C19.0844 11.8057 18.8958 12.5097 19.0806 13.165C19.364 14.1707 18.7627 15.2122 17.75 15.4696C17.0901 15.6373 16.5748 16.1526 16.4071 16.8125C16.1497 17.8252 15.1082 18.4265 14.1025 18.1431C13.4472 17.9583 12.7432 18.1469 12.268 18.6346C11.5388 19.3829 10.3362 19.3829 9.60698 18.6346C9.13176 18.1469 8.42784 17.9583 7.77246 18.1431C6.76681 18.4265 5.72528 17.8252 5.46793 16.8125C5.30021 16.1526 4.78491 15.6373 4.12497 15.4696C3.11232 15.2122 2.51099 14.1707 2.79445 13.165C2.97917 12.5097 2.79056 11.8057 2.30289 11.3305C1.55459 10.6013 1.55459 9.39867 2.30289 8.66948C2.79056 8.19426 2.97917 7.49034 2.79445 6.83496C2.51099 5.82931 3.11232 4.78778 4.12497 4.53043C4.78491 4.36271 5.30021 3.84741 5.46793 3.18747C5.72528 2.17482 6.76681 1.57349 7.77246 1.85695C8.42784 2.04167 9.13176 1.85306 9.60698 1.36539Z"
        fill="#086EE5"
      />
      <path
        d="M7.99951 9.90476L10.062 12L13.9995 8"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default VerifiedBadge;
